<template>
    <div class="page-wrapper container xl:max-w-[900px] mx-auto py-8 px-4 grid gap-2">
        <div class="text-center mt-6">
            <h2>Reset Your Password</h2>
            <p>Enter the new password you wish to log in with.</p>
        </div>

        <div class="mb-6" v-if="hasSuccess || hasError">
            <Alert type="success" title="Done!" v-if="hasSuccess">
                Success!
            </Alert>
            <Alert type="danger" title="Error!" v-if="hasError">
                <span v-html="errorText"></span>
            </Alert>
        </div>

        <ValidationObserver v-slot="{handleSubmit}" tag="div">
            <form autocomplete="off" @submit.prevent="handleSubmit(submitReset)" method="post">
                <ValidationProvider class="flex flex-col mb-3" mode="eager" name="password" rules="required|min:8" v-slot="{errors, invalid, validated}" tag="div">
                    <label for="password" class="text-sm">Password</label>
                    <input name="password" type="password" id="password" class="w-full bg-leonard-white placeholder:text-leonard-black-disabled text-leonard-black rounded lg:rounded-md p-4 border border-leonard-grey-disabled focus:outline-none focus:border-leonard-black-hover" :class="{'border-leonard-error': invalid && validated}" placeholder="password" v-model="password" autofocus>
                    <p class="text-sm text-leonard-error mt-1">{{errors[0]}}</p>
                </ValidationProvider>

                <ValidationProvider class="flex flex-col mb-3" mode="eager" name="password_confirmation" rules="required|min:8|confirmed:password" v-slot="{errors, invalid, validated}" tag="div">
                    <label for="password_confirmation" class="text-sm">Password Confirmation</label>
                    <input name="password_confirmation" type="password" id="password_confirmation" class="w-full bg-leonard-white placeholder:text-leonard-black-disabled text-leonard-black rounded lg:rounded-md p-4 border border-leonard-grey-disabled focus:outline-none focus:border-leonard-black-hover" :class="{'border-leonard-error': invalid && validated}" placeholder="confirm password" v-model="password_confirmation">
                    <p class="text-sm text-leonard-error mt-1">{{errors[0]}}</p>
                </ValidationProvider>

                <div class="flex justify-end mt-6">
                    <button type="submit" class="font-medium transition-all duration-300 border-2 rounded-md inline-block py-2 px-3 md:px-4 bg-leonard-green border-leonard-green text-leonard-white hover:bg-leonard-green-hover hover:border-transparent focus:ring-leonard-green cursor-pointer disabled:bg-leonard-green-disabled disabled:text-leonard-green disabled:cursor-not-allowed" :disabled="loading || hasSuccess">
                        Save New Password <font-awesome-icon fixed-width icon="spinner" pulse class="ml-2" v-if="loading"></font-awesome-icon>
                    </button>
                </div>
            </form>
        </ValidationObserver>
    </div>
</template>

<script>
    import {library} from "@fortawesome/fontawesome-svg-core";
    import {faSpinner} from "@fortawesome/free-solid-svg-icons";
    import { required, confirmed, min } from 'vee-validate/dist/rules';
    import { ValidationProvider, ValidationObserver, extend} from 'vee-validate';

    import User from '../classes/User';
    import Alert from "../components/app/Alert.vue";

    extend('required', {
        ...required,
        message: (fieldName) => {
            fieldName = fieldName.toLowerCase().split('_').map(function(word) {
                return (word.charAt(0).toUpperCase() + word.slice(1));
            }).join(' ');

            return `${fieldName} is required.`;
        }
    });

    extend('confirmed', {
        ...confirmed,
        message: (fieldName) => {
            fieldName = fieldName.toLowerCase().split('_').map(function(word) {
                return (word.charAt(0).toUpperCase() + word.slice(1));
            }).join(' ');

            return `${fieldName} does not match.`;
        }
    });

    extend('min', {
        ...min,
        message: (fieldName) => {
            fieldName = fieldName.toLowerCase().split('_').map(function(word) {
                return (word.charAt(0).toUpperCase() + word.slice(1));
            }).join(' ');

            return `${fieldName} must be at least 8 characters`;
        }
    });

    export default {
        data() {
            return {
                User: new User(),
                email: this.$route.query.email,
                password: '',
                password_confirmation: '',
                token: this.$route.params.token,
                errorText: '',
                hasError: false,
                hasSuccess: false,
                loading: false,
            }
        },

        components: {
            Alert,
            ValidationProvider,
            ValidationObserver,
        },

        created() {
            library.add(faSpinner);
        },

        beforeMount() {
            if(this.loggedIn()) this.$router.push({name: 'home'});
        },

        mounted() {
            document.querySelector('header').classList.add('solid');
            window.events.$emit('finishedLoading');
        },

        methods: {
            submitReset() {
                const self = this;
                let data = {
                    emailAddress: this.email,
                    password: this.password,
                    password_confirmation: this.password_confirmation,
                    token: this.token
                }

                this.loading = true;
                this.hasError = false;

                this.User.updatePassword(data).then(response => {
                    if(!response.success) {
                        self.hasError = true;
                        if(response.message === 'password.user') {
                            self.errorText = 'Could not find the user.';
                        } else if(response.message === 'password.token') {
                            self.errorText = 'The token is invalid.';
                        } else if (response.message) {
                            self.errorText = response.message;
                        } else {
                            self.errorText = 'An error occurred while saving the password. Please try again.'
                        }
                    } else {
                        self.hasSuccess = true;
                        self.$router.push({name: 'login'});
                        feedback('Password successfully reset!', 'success');
                    }

                    self.loading = false;
                })
            }
        }
    }
</script>
